import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { CustomDateDialogComponent } from '../custom-date-dialog-component/custom-date-dialog-component';
import { CommonModule } from '@angular/common';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialog } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'time-range-selector',
  standalone: true,
  imports: [
    CustomDateDialogComponent,
    CommonModule,
    MatButtonToggleModule,
    FormsModule
  ],
  templateUrl: './time-range-selector.html',
  styleUrl: './time-range-selector.scss'
})
export class TimeRangeSelector implements OnInit {

  @Output() timeRangeChange = new EventEmitter<{ start: Date, end: Date }>();

  // expliziter Typ für bessere Sicherheit
  selectedPreset: 'day' | 'week' | 'month' | 'year' | 'custom' = 'month';

  // werden im onInit via onPresetChange überschrieben
  customStart: Date | null = (() => {
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    return start;
  })();
  customEnd: Date | null = new Date();

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    // WICHTIG: Initiale Befüllung basierend auf selectedPreset
    this.onPresetChange(this.selectedPreset);
  }

  openCustomDialog() {
    const dialogRef = this.dialog.open(CustomDateDialogComponent, {
      data: { start: this.customStart, end: this.customEnd }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.customStart = result.start;
        this.customEnd = result.end;
        this.selectedPreset = 'custom';
        this.emitTimeRangeChange();
      } else if (this.selectedPreset === 'custom' && !(this.customStart && this.customEnd)) {
        this.selectedPreset = 'day';
      }
    });
  }

  onPresetChange(preset: 'day' | 'week' | 'month' | 'year' | 'custom') {
    if (preset === 'custom') return;

    this.selectedPreset = preset;
    const now = new Date();
    switch (preset) {
        case 'day': {
          const start = new Date(now);
          start.setHours(0, 0, 0, 0);
          this.customStart = start;
          this.customEnd = new Date(now);
          break;
        }
        case 'week': {
          // Start der Woche (So=0). Falls Mo als Wochenstart gewünscht: ((dow+6)%7)
          const dow = now.getDay(); // 0..6
          const startOfWeek = new Date(now);
          startOfWeek.setDate(now.getDate() - dow);
          startOfWeek.setHours(0, 0, 0, 0);

          const endOfWeek = new Date(startOfWeek);
          endOfWeek.setDate(startOfWeek.getDate() + 6);
          endOfWeek.setHours(23, 59, 59, 999);

          this.customStart = startOfWeek;
          this.customEnd = endOfWeek;
          break;
        }
        case 'month': {
          const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
          startOfMonth.setHours(0, 0, 0, 0);

          const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
          endOfMonth.setHours(23, 59, 59, 999);

          this.customStart = startOfMonth;
          this.customEnd = endOfMonth;
          break;
        }
        case 'year': {
          const startOfYear = new Date(now.getFullYear(), 0, 1);
          startOfYear.setHours(0, 0, 0, 0);

          const endOfYear = new Date(now.getFullYear(), 11, 31);
          endOfYear.setHours(23, 59, 59, 999);

          this.customStart = startOfYear;
          this.customEnd = endOfYear;
          break;
        }
      }

    this.emitTimeRangeChange();
  }

  private emitTimeRangeChange() {
    if (this.customStart && this.customEnd) {
      this.timeRangeChange.emit({
        start: this.customStart,
        end: this.customEnd
      });
    }
  }
}
